import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import TireManufacturer from './tire-manufacturer';
import TireManufacturerUpdate from './tire-manufacturer-update';
import TireManufacturerDeleteDialog from './tire-manufacturer-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TireManufacturerUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TireManufacturerUpdate} />
      <ErrorBoundaryRoute path={match.url} component={TireManufacturer} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={TireManufacturerDeleteDialog} />
  </>
);

export default Routes;
